export default __webpack_public_path__ + "static/media/celulares.ee49f85f.png";